export const HP_BUY_AGAIN_GA_LIST_NAME = 'PCC HP BUY Again';
const PRIMARY_GA_EVENT_CTA = 'e_primaryCTA';

export const BUY_AGAIN_GA_EVENT = {
  addToCartCTA: {
    gaprimaryCTA: PRIMARY_GA_EVENT_CTA,
    gaBtnEventName: 'add to cart',
    gaEventContext: 'Add to cart Buy Again section'
  },
  contactDealerCTA: {
    gaprimaryCTA: PRIMARY_GA_EVENT_CTA,
    gaBtnEventName: 'Contact Dealer',
    gaEventContext: 'Contact Dealer buy again section'
  },
  viewReplacementCTA: {
    gaprimaryCTA: PRIMARY_GA_EVENT_CTA,
    gaBtnEventName: 'View Replacement',
    gaEventContext: 'view replacement buy again section'
  },
  listNameAndId: HP_BUY_AGAIN_GA_LIST_NAME,
  gaEventFormLocation: 'PCC Home Page Buy Agin section'
};

export const VIEWALL_BUY_AGAIN_GAEVENTS = {
  PRIMARY_CTA: PRIMARY_GA_EVENT_CTA,
  CONTEXT: 'HP Buy agin section',
  BUTTON_EVENT_NAME: 'view all'
};

export const BUY_AGAIN_SCROLL_PRODUCT = 20;
export const BUY_AGAIN_PRODUCTS_PAGE_PATH = '/buy-again-products';
